export const elRed = '#EB1C22';
export const elGreen = '#006B00';
export const elGray = '#D9D9D9';
export const iconGray = '#828282';
export const elLightGray = '#F0F0F0';
export const elLightLightGray = '#F9F9F9';
export const mentionHighlight = '#d5eff7';

export const buttonBackground = elRed;
export const titleColor = elRed;
export const titleBackground = elGreen;
export const informationText = elRed;
export const textGray = elGray;
export const disabled = iconGray;

export default elRed;
